import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ApiService } from './api.service';
import { MeterTypes } from '@app/shared/models/meter-types';

@Injectable({
  providedIn: 'root',
})
export class MeterTypesService extends ApiService {
  private cache$?: Observable<MeterTypes[]>;

  constructor(public http: HttpClient) {
    super(http);
  }

  public getAllActive(): Observable<MeterTypes[]> {
    if (!this.cache$) {
      this.cache$ = this.requestMeterTypes().pipe(shareReplay(1));
    }
    return this.cache$;
  }

  private requestMeterTypes(): Observable<MeterTypes[]> {
    const uri = `socrates/meters/api/references/MeterTypes?$filter=isActive&$orderBy=sortOrder`;
    return this.http.get<MeterTypes[]>(this.endpoint(uri));
  }
}
